class config {
    constructor() {
        
    }

    url() {
        // return "http://localhost:8080";
        return 'https://apps.macrofox.fr';
        // return 'http://192.168.56.103:8088';
    }
    
    url_cloud(){
        return 'https//cloud.macrofox.fr';
    }
}

export default new config()